import React, { Component } from 'react';
import { Modal, Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, HelpBlock, ButtonToolbar, Button } from 'react-bootstrap';
import DatePicker from 'react-16-bootstrap-date-picker';
import { TableButton } from '../../../TableButton';

export class EditionEditMultipleIntervalsForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            originalIntervals: this.props.value.intervals.map(interval => Object.assign({}, interval))
        };
    }

    renderAddIntervalButton(operation) {
        if("archive" === operation) {
            return null;
        }

        return <Button className="pull-right" onClick={() => this.props.onAddIntervalEditForm()}> ADICIONAR INTERVALO </Button>;
    }

    getButtonText(operation) {
        if ("publish" === operation) {
            return "PUBLICAR";
        }

        if ("archive" === operation) {
            return "ARQUIVAR";
        }

        return "GUARDAR ALTERAÇÕES";
    }

    renderEmptyColumn(operation, force = false) {
        if (force || "publish" === operation || "edit" === operation) {
            return <Col className="padding-0" xs={1}></Col>;
        }

        return null;
    }

    renderRemoveIntervalIcon(operation, interval) {
        if ("publish" === operation || "edit" === operation) {
            return (
                <Col className="padding-0 text-align-center" xs={1}>
                    <TableButton icon="icon-error"
                        title="Remover Intervalo"
                        onClick={() => this.props.onRemoveIntervalEditForm(interval)} />
                </Col>
            );
        }

        return null;
    }

    renderHelpBlock(inputError, message) {
        if (null === inputError) {
            return null;
        }

        return (<HelpBlock>{message}</HelpBlock>);
    }

    renderNameFormControl(operation, value) {
        if ("publish" === operation || "archive" === operation) {
            return <p>{value.name}</p>;
        }

        return (
            <FormControl
                type="text"
                value={value.name}
                placeholder="Introduza o Nome"
                onChange={(a) => this.props.onChangeValue(a, "name")}
            />
        );
    }

    renderStartDateFormControl(operation, value) {
        if ("archive" === operation) {
            return <p>{value.startDate}</p>;
        }

        return (
            <DatePicker
                id="editionStartDatePicker"
                dateFormat="DD/MM/YYYY"
                value={value.startDate}
                placeholder="DD/MM/YYYY"
                onChange={(a) => this.props.onChangeDateValue(a, value, "startDate")} />
        );
    }

    renderEndDateFormControl(operation, value) {
        const { originalIntervals } = this.state;

        if ("archive" === operation && undefined !== originalIntervals.find(interval => interval.id === value.id).endDate) {
            return <p>{value.endDate}</p>;
        }

        return (
            <DatePicker
                id="editionEndDatePicker"
                dateFormat="DD/MM/YYYY"
                value={value.endDate}
                placeholder="DD/MM/YYYY"
                onChange={(a) => this.props.onChangeDateValue(a, value, "endDate")} />
        );
    }

    render() {
        const { value, operation, nameInputError, startDateInputError, endDateInputError,
            nameErrorMessage, startDateErrorMessage, endDateErrorMessage } = this.props;

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Editar</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={nameInputError} >
                            <ControlLabel>Nome</ControlLabel>
                            {this.renderNameFormControl(operation, value)}
                            {this.renderHelpBlock(nameInputError, nameErrorMessage)}
                        </FormGroup>

                        <Grid fluid>
                            <Row>
                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formStartDate" validationState={startDateInputError}>
                                        <ControlLabel>Data Início</ControlLabel>
                                    </FormGroup>
                                </Col>

                                {this.renderEmptyColumn(operation, true)}

                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                                        <ControlLabel>Data Fim</ControlLabel>
                                    </FormGroup>
                                </Col>

                                {this.renderEmptyColumn(operation)}
                            </Row>

                            {
                                value.intervals.map((interval, idx) =>
                                    <Row key={`row-${idx}`}>
                                        <Col className="padding-0" xs={5}>
                                            <FormGroup controlId="formStartDate" validationState={startDateInputError}>
                                                {this.renderStartDateFormControl(operation, interval)}
                                            </FormGroup>
                                        </Col>

                                        {this.renderEmptyColumn(operation, true)}

                                        <Col className="padding-0" xs={5}>
                                            <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                                                {this.renderEndDateFormControl(operation, interval)}
                                            </FormGroup>
                                        </Col>

                                        {this.renderRemoveIntervalIcon(operation, interval)}
                                    </Row>
                                )
                            }

                            <Row>
                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formStartDate" validationState={startDateInputError}>
                                        {this.renderHelpBlock(startDateInputError, startDateErrorMessage)}
                                    </FormGroup>
                                </Col>

                                {this.renderEmptyColumn(operation, true)}

                                <Col className="padding-0" xs={5}>
                                    <FormGroup controlId="formEndDate" validationState={endDateInputError}>
                                        {this.renderHelpBlock(endDateInputError, endDateErrorMessage)}
                                    </FormGroup>
                                </Col>

                                {this.renderEmptyColumn(operation)}
                            </Row>
                        </Grid>
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={this.props.onSave}> {this.getButtonText(operation)} </Button>
                        <Button onClick={this.props.onHide}> CANCELAR </Button>
                        {this.renderAddIntervalButton(operation)}
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
